/**
 * @module:  log模块
 * @author: Liang Huang
 * @date: 2019-09-17 14:04:53
 */
export function warn(msg) {
  console.log('%c [Jsbridge log]:', 'background: chocolate; border-radius: 4px ; padding: 3px 0;;color: #fff', msg);
}
export function log(msg) {
  console.log('%c [Jsbridge error]:', 'background: red', msg);
}